import * as Yup from 'yup';

import { zipCodeNoMaskRegExp, phoneNoMaskRegExp, ssnNoMaskRegExp } from './regexp';

//Yup.string().zip()
const PASSWORD_REG_EXP = /^(?=.*\d)(?=.*[~!@#$%^&*_\-+=`|\\(){}[\]:;"'<>,.?/])(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;

Yup.setLocale({
  mixed: {
    required: function ({ path, label }) {
      const fieldName = label ? label : path;
      return `${fieldName} is required`;
    },
  },
});
Yup.addMethod(Yup.string, 'zip', function () {
  return this.matches(zipCodeNoMaskRegExp, {
    name: 'zip',
    message: 'Must be a valid 5 (9)-digit Zip Code',
    excludeEmptyString: true,
  });
});

//Yup.string().phone()
Yup.addMethod(Yup.string, 'phone', function () {
  return this.matches(phoneNoMaskRegExp, {
    name: 'phone',
    message: 'Must be a valid Phone Number',
    excludeEmptyString: true,
  });
});

//Yup.string().ssn()
Yup.addMethod(Yup.string, 'ssn', function () {
  return this.matches(ssnNoMaskRegExp, {
    name: 'phone',
    message: 'Not a valid SSN.  Must be in the format "###-##-####"',
    excludeEmptyString: true,
  });
});

Yup.addMethod(Yup.string, 'federalId', function () {
  return this.matches(ssnNoMaskRegExp, {
    name: 'federalId',
    message: 'Not a valid Federal Tax ID. Must be in the format "##-#######"',
    excludeEmptyString: true,
  });
});

//allow initial values as empty string
export const nullableDate = Yup.date()
  .nullable()
  .transform((value, originalValue) => {
    return originalValue ? value : null;
  });

const passwordPolicy = Yup.string()
  .matches(
    /^(?=.*\d)(?=.*[~!@#$%^&*_\-+=`|\\(){}[\]:;"'<>,.?/])(?=.*[a-z])(?=.*[A-Z]).{6,20}$/,
    'Password must have from 6 to 20 characters which contain at least one numeric di' +
      'git, one uppercase, one lowercase letter and one special character.',
  )
  .min(6)
  .max(20)
  .required();

Yup.addMethod(Yup.string, 'strongPassword', function () {
  return this.matches(
    PASSWORD_REG_EXP,
    'Password must have from 6 to 20 characters which contain at least one numeric digit, one uppercase, one lowercase letter and one special character.',
  );
});

const isRequiredField = (schema, path) => {
  try {
    return Yup.reach(schema, path).describe().tests.indexOf('required') > -1;
  } catch {
    return false;
  }
};

//Routing Number Check Digit Validation //
//this function multiplies digits 1,4,7 by 3, digits 2,5,8 by 7, and 3,6,9 by 1, and
//adds the results together. If the total is evenly divisible by 10, then the check digit is ok
//otherwise, it is not.  example "good" trn = 263181368
//var numbr = '263181368';
const BankRoutingNumberValidation = (routingnumber) => {
  let s = 0;
  let m = 0;
  let j = 0;

  for (let i = 0; i < 9; i++) {
    if (m === 0) j = 3;
    else if (m === 1) j = 7;
    else if (m === 2) j = 1;
    s += parseInt(routingnumber[i], 10) * j;
    m = ++m;
    if (m >= 3) {
      m = 0;
    }
  }
  return s !== 0 && s % 10 === 0 ? true : false;
};

function getRequiredMessage(meta) {
  try {
    return meta.path.substr(meta.path.indexOf('.') + 1).replace(/([a-z])([A-Z])/g, '$1 $2') + ' is required field';
  } catch {
    return meta.path + ' is required field';
  }
}

const isFieldRequired = (schema, path, values, context) => {
  try {
    const info = Yup.reach(schema, path, values, context);

    const required =
      info
        .describe()
        .tests.map((t) => t.name)
        .indexOf('required') > -1;
    return required;
  } catch {
    return false;
  }
};

export { BankRoutingNumberValidation, getRequiredMessage, isRequiredField, passwordPolicy, isFieldRequired };
